import { ModuleListItem } from '@app/components/module/moduleListItem';
import { IsoPopover } from '@app/components/uielements';
import { List } from 'antd';
import React, { useState } from 'react';
import { FaPlus } from 'react-icons/fa';
import { useHistory } from 'react-router-dom';

interface ModuleLink {
  name?: string;
  full_name?: string;
  type: string;
  url: string;
}

const moduleLinks: ModuleLink[] = [
  { name: 'Account', type: 'Account', url: '/dashboard/accounts/new' },
  { name: 'Deal', type: 'Deal', url: '/dashboard/deals/new' },
  { full_name: 'Contact', type: 'Contact', url: '/dashboard/contacts/new' },
  {
    name: 'Sales Draft',
    type: 'SalesOrder',
    url: '/dashboard/salesdrafts/new',
  },
];

export const TopbarAddModules: React.FC = () => {
  const [visible, setVisible] = useState(false);
  const history = useHistory();

  const handleVisibleChange = (newVisible: boolean) => {
    setVisible(newVisible);
  };

  const handleItemClick = (url: string) => {
    setVisible(false); // Close the popover when an item is clicked
    history.push(url);
  };

  const content = (
    <div className="topbarAddModule" style={{ width: '200px' }}>
      <List
        bordered
        dataSource={moduleLinks}
        renderItem={(item) => (
          <div onClick={() => handleItemClick(item.url)}>
            <ModuleListItem
              url={item.url}
              item={item}
              style={{ cursor: 'pointer' }}
            />
          </div>
        )}
      />
    </div>
  );

  return (
    <IsoPopover
      content={content}
      trigger="click"
      open={visible}
      onOpenChange={handleVisibleChange}
      arrowPointAtCenter={true}
      placement="bottomLeft"
      style={{ width: '200px' }}
    >
      <FaPlus className="topbar-icon" />
    </IsoPopover>
  );
};
